/**
 * Degraded rendering for rows written before the registry carried presentation
 * data — notifications whose `type_key` is still null.
 *
 * `notifications:backfill-context` stamps every registered type, so this path is
 * only reached by a type that has not been registered yet. It stays readable
 * rather than trying to replicate per-type wording: registering the type is the
 * fix, not growing this file.
 */
import { DEFAULT_STYLE } from './categoryStyle';

export default {
    style() {
        return DEFAULT_STYLE;
    },

    text(notification) {
        const data = notification.data || {};
        const firstValue = Object.values(data).find(v => typeof v === 'string');

        return firstValue || i18n.t('New notification');
    },

    route() {
        return null;
    }
};
